import useRouter from "common/hooks/use-router";
import useItem from "common/hooks/useItem";
import { useContext, useEffect } from "react";

import AlertsContext from "common/providers/alerts";
import ObservationResponseForm from "./ObservationResponseForm";

function ObservationResponse() {
  const router = useRouter();
  const { setAlert } = useContext(AlertsContext);

  const id = router.query.id as string;

  const { item, error, isFetching }: any = useItem(
    "observation-responses/data/list",
    id
  );

  useEffect(() => {
    if (error) {
      setAlert(error, "danger");
    }
  }, [error, setAlert]);

  return isFetching || (id && !item) ? null : (
    <ObservationResponseForm observationResponse={item} />
  );
}

export default ObservationResponse;
